import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Link,
  Text,
} from "@chakra-ui/react";

import { LinearCodingSessionTrustedSource } from "@reflag/shared/linearConnectionAPI";

const disabledReasonMessages: Record<
  NonNullable<LinearCodingSessionTrustedSource["disabledReason"]>,
  string
> = {
  APP_NOT_TRUSTED:
    "Add Reflag to “Trusted external sources” in Linear to automatically start coding sessions for cleanup issues.",
  CODING_SESSIONS_DISABLED:
    "Enable coding sessions in Linear to automatically start cleanup work.",
  TRUSTED_EXTERNAL_SOURCES_UNAVAILABLE:
    "Trusted external sources aren’t available in this Linear workspace.",
};

export function LinearCleanupTrustedSourceWarning({
  status,
  workspaceUrlKey,
}: {
  status: LinearCodingSessionTrustedSource;
  workspaceUrlKey: string;
}) {
  if (status.enabled) return null;

  const message =
    (status.disabledReason && disabledReasonMessages[status.disabledReason]) ||
    "Reflag can’t automatically start coding sessions in this Linear workspace.";

  return (
    <Alert status="warning" role="status" alignItems="flex-start" mt={4}>
      <AlertIcon />
      <Box fontSize="sm">
        <AlertTitle>Automatic coding sessions unavailable</AlertTitle>
        <Text>{message}</Text>
        <Text mt={2}>Cleanup issues will still be created.</Text>
        <Link
          href={`https://linear.app/${encodeURIComponent(workspaceUrlKey)}/settings/ai/coding-agent`}
          isExternal
          textDecoration="underline"
        >
          Open Linear settings
        </Link>
      </Box>
    </Alert>
  );
}
